export { default } from './RegAndEditAdvertise';